import React, { useState } from 'react';

/**
 * Motif « non qualifié » en LISTE FERMÉE (CHECK appointments_not_qualified_reason_check +
 * dico hook-brain §1.4). L'ancien window.prompt en texte libre heurtait la contrainte →
 * l'UPDATE échouait et la qualification du client n'était jamais enregistrée (audit 08/10).
 * La note libre est OPTIONNELLE et part dans p_note (journalisée dans appointment_events).
 */
export const NQ_REASONS: { value: string; label: string }[] = [
  { value: 'hors_icp', label: 'Hors cible' },
  { value: 'mauvais_interlocuteur', label: 'Mauvais interlocuteur' },
  { value: 'pas_de_besoin_exprime', label: 'Pas de besoin exprimé' },
  { value: 'questions_non_posees', label: 'Questions de qualification non posées' },
  { value: 'information_erronee', label: 'Information erronée' },
  { value: 'autre', label: 'Autre' },
];

export const NqReasonForm: React.FC<{
  busy?: boolean;
  onSubmit: (reason: string, note?: string) => void;
  onCancel: () => void;
}> = ({ busy, onSubmit, onCancel }) => {
  const [reason, setReason] = useState<string>('');
  const [note, setNote] = useState('');
  return (
    <div>
      <p className="text-[14px] font-semibold mb-2">Pourquoi ce rendez-vous n'est-il pas qualifié ?</p>
      <div className="space-y-1.5 mb-3">
        {NQ_REASONS.map(r => (
          <label key={r.value} className={`flex items-center gap-2 text-[13px] px-3 py-2 rounded-lg border cursor-pointer transition ${reason === r.value ? 'border-ink bg-panel-2' : 'border-line hover:border-ink'}`}>
            <input type="radio" name="nq-reason" value={r.value} checked={reason === r.value} onChange={() => setReason(r.value)} />
            {r.label}
          </label>
        ))}
      </div>
      <textarea
        value={note} onChange={e => setNote(e.target.value)} rows={2}
        placeholder="Précision (optionnel)"
        className="w-full text-[13px] border border-line rounded-lg px-3 py-2 mb-3 bg-transparent"
      />
      <div className="flex gap-2">
        <button disabled={busy || !reason} onClick={() => onSubmit(reason, note.trim() || undefined)}
          className="flex-1 text-[13px] font-semibold px-4 py-2.5 rounded-lg border border-st-bad/40 text-st-bad hover:bg-st-bad/5 disabled:opacity-40 transition">
          Confirmer « non qualifié »
        </button>
        <button disabled={busy} onClick={onCancel}
          className="text-[13px] px-4 py-2.5 rounded-lg border border-line-2 text-dim hover:border-ink transition">
          Annuler
        </button>
      </div>
    </div>
  );
};

/** Variante overlay autonome (pour les pages registre / à statuer). */
export const NqReasonModal: React.FC<{
  busy?: boolean;
  onSubmit: (reason: string, note?: string) => void;
  onCancel: () => void;
}> = (props) => (
  <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" onClick={props.onCancel}>
    <div className="bg-panel border border-line rounded-card w-full max-w-md p-6 shadow-2xl" onClick={e => e.stopPropagation()}>
      <NqReasonForm {...props} />
    </div>
  </div>
);
